<template>
  <div class>
    <div class="d-flex flex-row workspace-navbar">
      <div class="flex-grow-1">
        <div class="d-flex">
          <div
            class="d-flex"
            style="position: absolute; top: 0; left: 0; height: 50px"
          >
            <div class="nineDotsMainDiv1">
              <a :href="`#/${$route.params.account_id}/workspace`">
                <div
                  class="nineDotsHover"
                  style="border-radius: 25px; width: 40px; height: 40px"
                >
                  <div class="dineDotsDiv">
                    <img
                      src="static/img/homeDashboard.svg"
                      height="20"
                      width="20"
                    />
                  </div>
                </div>
              </a>
            </div>
            <div
              class="d-flex dropdown-switch-div"
              v-if="$route.params && $route.params.workspace_id"
            >
              <b-dropdown
                id="dropdown-grouped"
                variant="link"
                toggle-class="text-decoration-none switch-workspace"
                class="workspaceSwitchDropdown style-3"
              >
                <template v-slot:button-content>
                  <div class="d-flex" style="/*padding-top:10px*/">
                    <div style="margin-right: 8px">
                      <b-avatar
                        variant="warning"
                        :size="30"
                        style="color: white"
                        square
                        :text="avatarText"
                        :src="currentWorkspaceAvatarLogo"
                      ></b-avatar>
                    </div>
                    <div style="width: 145px">
                      <div
                        style="
                          text-align: left;
                          font-size: 12px;
                          color: #fcfcfc;
                        "
                        class="infoTitle"
                        v-if="
                          currentWorkspace && currentWorkspace.workspace_title
                        "
                        :title="currentWorkspace.workspace_title"
                      >
                        {{ currentWorkspace.workspace_title }}
                      </div>
                      <div style="text-align: left" v-else>Untitled</div>
                      <div
                        style="
                          text-align: left;
                          font-size: 10px;
                          color: #fcfcfc;
                        "
                        class="infoType"
                        v-if="
                          currentWorkspace && currentWorkspace.workspace_type
                        "
                      >
                        {{ currentWorkspace.workspace_type }}
                      </div>
                    </div>
                  </div>
                </template>
                <b-dropdown-group id="dropdown-group-1" header="PERSONAL">
                  <template v-for="item in myWorkspaces" >
                    <b-dropdown-item-button
                      v-if="userAllowedWorkspaces.includes(item.workspace_type)"
                      :key="item.workspace_id"
                    >
                      <div
                        class="d-flex"
                        style="padding-top: 8px; padding-bottom: 8px"
                        @click="switchWorkspaces(item)"
                      >
                        <div style="margin-right: 8px">
                          <b-avatar
                            rounded="lg"
                            variant="success"
                            :size="30"
                            style="color: white"
                            square
                            :text="workspaceTitleText(item.workspace_title)"
                            :src="avatarLogo(item)"
                          ></b-avatar>
                        </div>
                        <div class="workspaceItemCls">
                          <div
                            style="color: #000000b3; text-align: left"
                            class="infoTitle"
                            :title="item.workspace_title"
                          >
                            {{ item.workspace_title }}
                          </div>
                          <div
                            style="
                              font-size: 11px;
                              color: #000000b3;
                              text-align: left;
                            "
                            class="infoType"
                          >
                            {{ item.workspace_type }}
                          </div>
                        </div>
                      </div>
                    </b-dropdown-item-button>
                  </template>
                </b-dropdown-group>
                <b-dropdown-group
                  id="dropdown-group-2"
                  class="sharedWorkspaceItem"
                  v-if="sharedWorkspace.length > 0"
                  header="SHARED"
                >
                  <b-dropdown-item-button
                    v-for="item in sharedWorkspace"
                    :key="item.workspace_id"
                  >
                    <div
                      class="d-flex"
                      style="padding-top: 8px; padding-bottom: 8px"
                      @click="switchWorkspaces(item)"
                    >
                      <div style="margin-right: 8px">
                        <b-avatar
                          rounded="lg"
                          variant="success"
                          :size="30"
                          style="color: white"
                          square
                          :text="workspaceTitleText(item.workspace_title)"
                          :src="avatarLogo(item)"
                        ></b-avatar>
                      </div>
                      <div class="workspaceItemCls">
                        <div
                          style="color: #000000b3; text-align: left"
                          class="infoTitle"
                          :title="item.workspace_title"
                        >
                          {{ item.workspace_title }}
                        </div>
                        <div
                          style="
                            font-size: 11px;
                            color: #000000b3;
                            text-align: left;
                          "
                          class="infoType"
                        >
                          {{ item.workspace_type }}
                        </div>
                      </div>
                    </div>
                  </b-dropdown-item-button>
                  <!-- <b-dropdown-item-button>Second Grouped Item</b-dropdown-item-button> -->
                </b-dropdown-group>
              </b-dropdown>
            </div>
            <div
              class="activateProLayout"
              @click="activatePro"
              v-if="showActivateProButton"
              style="margin-left:8px;margin"
            >
              <div class="activateProButton">Activate Pro</div>
            </div>
          </div>
          <div
            class="workspaceLogoMainLayout"
            @click="$router.push(`/${$route.params.account_id}/workspace`)"
          >
            <div class="workspace-logo">fiifi</div>
          </div>
        </div>
      </div>
      <div class="d-flex">
        <!-- {{checkRead}} -->
        <div
          class="mr-3"
          @click="showThisNotification"
          style="
            cursor: pointer;
            margin-top: auto;
            margin-bottom: auto;
            position: relative;
          "
        >
          <!-- <img v-if="checkRead" src="static/img/notifications-outline.svg" /> -->
          <!-- <div v-if="checkRead" class="read"></div> -->
          <img
            src="static/img/notifications-outline_update.svg"
            v-if="checkRead"
          />
          <img src="static/img/notifications_update.svg" v-else />
          <!-- <i class="fa-workspace-icon fa fa-bell"></i> -->
        </div>
        <div
          class="pb-3"
          style="padding-left: 1.1rem !important; display: none"
        >
          <i class="fa fa-question-circle fa-workspace-icon"></i>
        </div>
        <!-- <div class="p-2 workspace-account" @click="isOpen = !isOpen">
          <img
            style="cursor: pointer; height: 100%"
            v-bind:src="`${
              user.image && user.image.length > 0
                ? user.image
                : 'static/img/faces/face-0.jpg'
            }`"
            class="w-100 rounded-circle"
          />
        </div> -->
        <div class="workspace-account p-2" @click="isOpen = !isOpen">
          <b-avatar
            :text="
              user && user.firstName
                ? avatarNavbarUserText(user.firstName)
                : avatarNavbarUserText('')
            "
            class="align-baseline navbarProfileAvatar"
            :style="`background:${backgroundColor(
              user
            )};min-width:100%;min-height:100%;border-radius:50%;height:auto`"
            :src="avatarNavbarUserLogo(user.image)"
          ></b-avatar>
        </div>
      </div>
    </div>
    <div
      v-if="isOpen"
      id="profilePopup"
      class="d-flex flex-wrap"
      style="justify-content: flex-end"
    >
      <div class="accountClass">
        <div class="accountChildCls w-100">
          <div class="d-flex p-3 pt-4 singleAccount">
            <div>
              <!-- <img
                v-bind:src="`${
                  user.image && user.image.length > 0
                    ? user.image
                    : 'static/img/faces/face-0.jpg'
                }`"
                width="40"
                height="40"
                class="rounded-circle"
              /> -->
              <div
                class="navbarWorkspaceProfileLogoChild"
                @click="isOpen = !isOpen"
              >
                <b-avatar
                  :text="
                    user && user.firstName
                      ? avatarNavbarUserText(user.firstName)
                      : avatarNavbarUserText('')
                  "
                  class="align-baseline navbarProfileAvatarChild"
                  :style="`background:${backgroundColor(
                    user
                  )};min-width:100%;min-height:100%;border-radius:50%;height:auto`"
                  :src="avatarNavbarUserLogo(user.image)"
                ></b-avatar>
              </div>
            </div>
            <div class="pl-3">
              <div style="word-break: break-all">
                {{ user.firstName }} {{ user.lastName }}
              </div>
              <div class="nameEmailAccount">{{ user.email }}</div>
              <div class>
                <a :href="`#/${$route.params.account_id}/profile`"
                  >Profile Settings</a
                >
              </div>
            </div>
          </div>
          <div v-if="fiifiUsers.length > 0">
            <div
              class="d-flex pt-2 pb-2 singleAccount"
              v-for="item in fiifiUsers"
              v-bind:key="item._id"
              @click="switchAccount(item)"
              style="cursor: pointer"
            >
              <div class="pl-3">
                <!-- <img
                  v-bind:src="`${
                    item.image && item.image.length > 0
                      ? item.image
                      : 'static/img/faces/face-0.jpg'
                  }`"
                  width="40"
                  height="40"
                  class="rounded-circle"
                /> -->
                <div
                  class="navbarWorkspaceProfileLogoChild"
                  @click="isOpen = !isOpen"
                >
                  <b-avatar
                    :text="
                      item && item.firstName
                        ? avatarNavbarUserText(item.firstName)
                        : avatarNavbarUserText('')
                    "
                    class="align-baseline navbarProfileAvatarChild"
                    :style="`background:${backgroundColor(
                      item
                    )};min-width:100%;min-height:100%;border-radius:50%;height:auto`"
                    :src="avatarNavbarUserLogo(item.image)"
                  ></b-avatar>
                </div>
              </div>
              <div class="pl-3 pt-1">
                <div style="word-break: break-all">
                  {{ item.firstName }} {{ item.lastName }}
                </div>
                <div class="nameEmailAccount">{{ item.email }}</div>
              </div>
            </div>
          </div>
          <div
            class="d-flex p-2"
            style="cursor: pointer; line-height: 26px"
            @click="addAccount"
          >
            <div class="pl-4" style="font-size: 14px; color: #646464">
              <i class="fa fa-user-plus"></i>
            </div>
            <div class style="padding-left: 1.4rem">Add Account</div>
          </div>
          <div class="d-flex p-2" style="cursor: pointer" @click="Logout">
            <div class="pl-4" style="font-size: 16px; color: #646464">
              <i class="fa fa-sign-out-alt"></i>
            </div>
            <div class style="padding-left: 1.4rem">Log out</div>
          </div>
        </div>
      </div>
    </div>
    <b-sidebar
      id="sidebar-right"
      title="Sidebar"
      ref="notificationRef"
      :visible="showSideBar"
      @hidden="
        showSideBar = false;
        notifyTab = '';
      "
      bg-variant="white"
      width="380px"
      no-header
      right
      shadow
    >
      <div class="d-flex" style="padding: 20px; justify-content: space-between">
        <div class="notifyHeaderText">Notification Center</div>
        <div class="notifyClose" @click="showSideBar = false">
          <img src="static/img/close.svg" />
        </div>
      </div>
      <b-tabs v-if="haveWorkspaceId">
        <b-tab
          title="This workspace"
          active-nav-item-class="ml-2 border-bottom: #5445F3 0% 0% no-repeat padding-box"
          @click="showThisNotification"
          active
        >
          <ThisNotification ref="ThisNotifyRef"></ThisNotification>
        </b-tab>
        <b-tab title="All" @click="showAllNotification">
          <AllNotification ref="AllNotifyRef"></AllNotification>
        </b-tab>
      </b-tabs>
      <div v-else>
        <AllNotification></AllNotification>
      </div>
    </b-sidebar>
    <DialogAddTodo
      v-if="showDialogModal"
      v-model="dialogTodoData"
    ></DialogAddTodo>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import api from "../../../axios_api";
import SwitchNotification from "../../Dashboard/Components/SwitchNotification";
import config from "../../../../config/settings";
import ThisNotification from "../Pages/ThisNotification";
import AllNotification from "../Pages/AllNotification";
import DialogAddTodo from "../Dialogs/DialogAddTodo";
import { pickBackgroundColor } from "../../../util/index";
export default {
  name: "navbar",
  components: {
    ThisNotification,
    AllNotification,
    DialogAddTodo,
  },
  data() {
    return {
      isOpen: false,
      email: "",
      showSideBar: false,
      haveWorkspaceId: false,
      notifyTab: "This",
      fiifiUsers: [],
      intervalNotification: 0,
      oldValue: true,
      showDialogModal: false,
      dialogTodoData: {
        isShow: false,
        isCreate: true,
        context: "",
        data: {},
      },
      userAllowedWorkspaces: []
    };
  },
  computed: {
    ...mapGetters("user", ["user"]),
    ...mapGetters("workspace", ["currentWorkspace", "workspaces"]),
    ...mapGetters("notifications", ["notifications"]),
    ...mapGetters("workspacePlans", ["feature", "plan"]),
    ...mapGetters("todo", ["context", "showModal"]),
    workspacesData() {
      let data = JSON.parse(JSON.stringify(this.workspaces));
      data = data.filter((item) => {
        if (item.clientName && item.clientName._id) return item;
      });
      let result = _.chain(data)
        .groupBy("clientName._id")
        .map(function (v, i) {
          return {
            clientId: i,
            client_name:
              v[0].clientName.firstName != v[0].clientName.lastName
                ? `${v[0].clientName.firstName} ${v[0].clientName.lastName}`
                : v[0].clientName.firstName,
            account_workspace: _.map(v),
          };
        })
        .value();
      result.map((item) => {
        if (item.account_workspace) {
          item.account_workspace.map((workspaceItem) => {
            workspaceItem.workspace_id = workspaceItem.workspace._id;
            workspaceItem.workspace_title = workspaceItem.workspace.title
              ? workspaceItem.workspace.title
              : "Untitled";
            workspaceItem.workspace_type = workspaceItem.workspace
              .workspace_type
              ? workspaceItem.workspace.workspace_type
              : "";
            workspaceItem.stages = workspaceItem.workspace.stages
              ? workspaceItem.workspace.stages
              : [];
            workspaceItem.sectors = workspaceItem.workspace.sectors
              ? workspaceItem.workspace.sectors
              : "";
          });
        }
      });
      return result;
    },
    myWorkspaces() {
      let data = this.workspacesData.find(
        (item) => item.clientId == this.$route.params.account_id
      );
      if (data) return data.account_workspace;
      else return [];
    },
    sharedWorkspace() {
      let data = [];
      let workspaces = this.workspacesData.filter(
        (item) => item.clientId != this.$route.params.account_id
      );
      workspaces.map((item) => {
        if (item.account_workspace) {
          item.account_workspace.map((item) => data.push(item));
        }
      });
      return data;
    },
    checkRead() {
      let read = this.notifications.findIndex((item) => {
        if (!item.isRead) return item;
      });
      if (read >= 0) return true;
    },
    avatarText() {
      if (this.currentWorkspace.workspace_title) {
        let text = this.currentWorkspace.workspace_title.split(" ");
        text =
          text.length > 1
            ? `${text[0].charAt(0)} ${text[1].charAt(0)}`
            : text[0].charAt(0);
        return text;
      } else return "WS";
    },
    sidebarStyle() {
      return {
        //backgroundImage: `url(${this.backgroundImage})`
        //background: "#f5f5f5 0% 0% no-repeat padding-box",
        "background-color": "rgb(241, 241, 242)",
        opacity: "1",
        "border-right": "1px solid #eaeaea",
      };
    },
    showActivateProButton() {
      let route = this.$route.name;
      if (route == "Workspace Dashboard") {
        let feature = this.$store.getters["accountPlans/feature"];
        if (feature && feature.length > 0) {
          let index = feature.findIndex((item) => {
            if (item == "ACTIVATE_PRO") {
              return item;
            }
          });
          if (index >= 0) {
            this.oldValue = true;
            return true;
          } else {
            this.oldValue = false;
            return false;
          }
        } else return this.oldValue;
      } else {
        let featureIndex = this.feature.findIndex((item) => {
          if (item == "ACTIVATE_PRO") return item;
        });
        if (featureIndex >= 0) return true;
        else return false;
      }
    },
    currentWorkspaceAvatarLogo() {
      let logo = "";
      if (
        this.currentWorkspace.hasOwnProperty("workspace_id") &&
        this.currentWorkspace.workspace_id.length > 0
      ) {
        let data = JSON.parse(JSON.stringify(this.workspaces));
        let workspace = data.find((item) => {
          if (item) {
            if (
              item.hasOwnProperty("workspace") &&
              item.workspace.hasOwnProperty("_id") &&
              item.workspace._id == this.currentWorkspace.workspace_id
            ) {
              return item;
            }
          }
        });
        if (
          workspace &&
          workspace.hasOwnProperty("workspace") &&
          workspace.workspace.hasOwnProperty("logo") &&
          workspace.workspace.logo.length > 0
        ) {
          logo = workspace.workspace.logo;
        }
      }
      return logo;
    },
  },
  methods: {
    pickBackgroundColor: pickBackgroundColor,
    switchWorkspaces(item) {
      this.$notifyClear();
      this.$notify({ component: SwitchNotification, timeout: 8000 });
      let userProfile = this.$store.getters["user/user"];
      let payload = {
        id: item.account,
        _id: item.account,
        workspace_id: item.workspace_id,
        image: userProfile.image ? userProfile.image : "",
        firstName: userProfile.firstName ? userProfile.firstName : "",
        lastName: userProfile.lastName ? userProfile.lastName : "",
        email: userProfile.email ? userProfile.email : "",
      };
      let fiifi = JSON.parse(localStorage.fiifi).user;
      if (fiifi && fiifi.workspace_id && fiifi.workspace_id.length > 0) {
        if (item.workspace_id == fiifi.workspace_id) {
          let data = this.$store.getters["portfolio/portfolioData"];
          this.$notifyClear();
          if (data && data.length > 0) {
            let url;
            if(item.hasOwnProperty("workspace_type")){
              if(item.workspace_type == "Limited Partner"){
                url = `/${payload._id}/${payload.workspace_id}/lpDashboard`;
              }else if(item.workspace_type == "SPV"){
                url = `/${payload._id}/${payload.workspace_id}/spvDashboard`
              }else{
                url = `/${payload._id}/${payload.workspace_id}/dashboard/overview`;
              }
            }
            this.$router.push(url).catch((err) => {});
            this.$router.go()
            return;
          } else {
            if(item.workspace_type == "SPV"){
              this.$router
              .push(`/${payload._id}/${payload.workspace_id}/spvDashboard`)
              .catch((err) => {});
              this.$router.go()
            }else{
              this.$router
              .push(`/${payload._id}/${payload.workspace_id}/portfolio`)
              .catch((err) => {});
              this.$router.go()
            }
            return;
          }
        }
      }
      var defaultPayload = {
        workspace_title: item.workspace_title,
        workspace_type: item.workspace_type,
        workspace_id: item.workspace_id,
        sectors: item.sectors,
        stages: item.stages,
        targetCapitalToDeployPercent: item.targetCapitalToDeployPercent,
        feeAndExpenseLoadAssumptionPercent:
          item.feeAndExpenseLoadAssumptionPercent,
      };

      this.$store.commit("workspace/setDefaultPipeline", {
        payload: defaultPayload,
      });
      this.$store.commit("user/workspace_id", {
        workspace_id: item.workspace_id,
      });
      this.$store
        .dispatch("workspacePlans/getWorkspacePlanFeatures", {
          workspace_id: item.workspace_id,
        })
        .then((plans) => {
          this.$store.dispatch("arbiter/start");
          this.$store
            .dispatch("dashboardCoordinates/apiFetchCoordinates")
            .then((data) => {
              this.$notifyClear();
              let url;
               if(item.hasOwnProperty("workspace_type")){
                if(item.workspace_type == "Limited Partner"){
                  url = `/${payload._id}/${payload.workspace_id}/lpDashboard`;
                }else if(item.workspace_type == "SPV"){
                  url = `/${payload._id}/${payload.workspace_id}/spvDashboard`
                }else{
                  url = `/${payload._id}/${payload.workspace_id}/dashboard/overview`;
                }
              }
              this.$router.push(url).catch((err) => {});
              this.$router.go()
            });
          // this.$store.dispatch("portfolio/apiFetchPortfolio").then((data) => {
          //   if (data && data.length > 0) {
          //     this.$router
          //       .push(
          //         `/${payload._id}/${payload.workspace_id}/dashboard/overview`
          //       )
          //       .catch((err) => {});
          //   } else {
          //     this.$notifyClear();
          //     this.$router
          //       .push(
          //         `/${payload._id}/${payload.workspace_id}/dashboard/overview`
          //       )
          //       .catch((err) => {});
          //   }
          // });
        });
    },
    openTodoModal() {
      if (this.context && this.showModal) {
        this.showDialogModal = true;
        this.dialogTodoData = {
          context: this.context,
          isShow: true,
          isCreate: true,
          data: {
            priority: "medium",
            due_date: new Date().setDate(new Date().getDate() + 3),
            status: "New",
            is_quick_task: false,
          },
          assigned_to: [this.$route.params.account_id],
        };
      }
    },
    showThisNotification() {
      this.showSideBar = true;
      if (this.$refs && this.$refs.ThisNotifyRef)
        this.$refs.ThisNotifyRef.getNotifications();
      if (
        this.$refs &&
        this.$refs.ThisNotifyRef &&
        this.$refs.ThisNotifyRef.headerText
      )
        this.$refs.ThisNotifyRef.headerText = "View Unread";
    },
    showAllNotification() {
      if (this.$refs && this.$refs.AllNotifyRef.headerText)
        this.$refs.AllNotifyRef.headerText = "View Unread";
    },
    workspaceTitleText(title) {
      let text = title.split(" ");
      text =
        text.length > 1
          ? `${text[0].charAt(0)} ${text[1].charAt(0)}`
          : text[0].charAt(0);

      return text;
    },
    async initScrollBarAsync() {
      await import("perfect-scrollbar/dist/css/perfect-scrollbar.css");
      const PerfectScroll = await import("perfect-scrollbar");
      PerfectScroll.initialize(this.$refs.sidebarScrollArea);
    },
    switchAccount(item) {
      this.$notifyClear();
      this.$notify({ component: SwitchNotification, timeout: 8000 });
      item.id = item._id;
      api
        .post("/switch/user", { encrypt: { data: item } })
        .then((data) => {
          this.isOpen = false;
          this.$store.dispatch("arbiter/shutdown");
          let user = data.data.encrypt.success.user;
          user.token = data.data.encrypt.success.token;
          user.isNew = data.data.encrypt.success.isNew;
          this.$store.commit("user/token", {
            token: data.data.encrypt.success.token,
          });
          user.email = item.email;
          if (item.image) user.image = item.image;
          this.$store.commit("user/user", {
            user,
          });
          // this.$store.dispatch("arbiter/start");
          window.localStorage.setItem("email", item.email);
          this.displayUser(user._id);
          this.$store.dispatch("notifications/start", null, { root: true });
          this.$store
            .dispatch("accountPlans/getAccountPlanFeatures")
            .then((plans) => {
              this.$store
                .dispatch("workspace/apiFetchworkspaces")
                .then((data) => {
                  this.$router.push(`/${user._id}/workspace`);
                });
            });
        })
        .catch((err) => console.log(err));
    },
    addAccount() {
      let user = JSON.parse(window.localStorage.getItem("fiifi")).user;
      let userObj = {
        _id: user._id || user.id,
        workspace_id: user.workspace_id,
        image: user.image,
        firstName: user.first_name,
        lastName: user.last_name,
        email: user.email,
      };
      if (window.localStorage.getItem("fiifiUsers")) {
        let users = JSON.parse(window.localStorage.getItem("fiifiUsers"));
        if (users.findIndex((item) => item._id == userObj._id) == -1) {
          window.localStorage.removeItem("fiifiUsers");
          users.push(userObj);
          window.localStorage.setItem("fiifiUsers", JSON.stringify(users));
        }
      } else {
        let users = [];
        users.push(userObj);
        window.localStorage.setItem("fiifiUsers", JSON.stringify(users));
      }
      this.$router.push("/login?redirect=account");
    },
    Logout() {
      window.sessionStorage.clear();
      this.$toaster.success("You have been successfully logged out.");
      if (localStorage.getItem("fiifiUsers") && this.$route.params.account_id) {
        let fiifiUsers = JSON.parse(localStorage.getItem("fiifiUsers"));
        let index = fiifiUsers.findIndex(
          (item) => item._id == this.$route.params.account_id
        );
        fiifiUsers.splice(index, 1);
        window.localStorage.setItem("fiifiUsers", JSON.stringify(fiifiUsers));
      }
      // if (window && window.intercomSettings) {
      //   if (window.intercomSettings.name) {
      //     delete window.intercomSettings.name;
      //   }
      //   if (window.intercomSettings.email) {
      //     delete window.intercomSettings.email;
      //   }
      //   if (window.Intercom) {
      //     window.Intercom("update");
      //     document.cookie =
      //       document.cookie + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
      //     window.Intercom("shutdown");
      //   }
      // }
      if (window.Intercom) {
        // window.Intercom("update");
        // document.cookie =
        //   document.cookie + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
        window.Intercom("shutdown");
      }
      window.clearInterval(this.intervalNotification);
      this.$router.push("/login");
    },
    displayUser(account_id) {
      if (localStorage.getItem("fiifiUsers") && this.$route.params.account_id) {
        this.fiifiUsers = JSON.parse(localStorage.getItem("fiifiUsers"));
        let index = this.fiifiUsers.findIndex((item) => item._id == account_id);
        this.fiifiUsers.splice(index, 1);
      }
    },
    scrollListener() {
      this.isOpen = false;
    },
    clickListener() {
      if (document.getElementById("profilePopup")) {
        this.isOpen = false;
      }
    },
    activatePro() {
      let url = config.ACTIVATE_PRO_LINK;
      api
        .patch(`/acticatePro/${this.$route.params.account_id}`, {})
        .then((data) => {})
        .catch((error) => {});
      window.open(url, "_blank");
    },
    getNotifications() {
      let self = this;
      self.$store.dispatch("notifications/getNotifications");
    },
    avatarLogo(item) {
      let logo = "";
      if (
        item.hasOwnProperty("workspace") &&
        item.workspace.hasOwnProperty("logo") &&
        item.workspace.logo.length > 0
      ) {
        logo = item.workspace.logo;
      }
      return logo;
    },
    avatarNavbarUserLogo(image) {
      let logo = "";
      if (image && image.length > 0) {
        logo = image;
      }
      this.showLoader = false;
      return logo;
    },
    avatarNavbarUserText(name) {
      if (name && name.length > 0) {
        let text = name.split(" ");
        text =
          text.length > 1
            ? `${text[0].charAt(0)}${text[1].charAt(0)}`
            : text[0].charAt(0);

        return text;
      } else {
        return "U";
      }
    },
    backgroundColor(item) {
      let image =
        item &&
        item.hasOwnProperty("image") &&
        item.image &&
        item.image.length > 0
          ? item.image
          : "";
      if (
        this.avatarNavbarUserLogo(image) &&
        this.avatarNavbarUserLogo(image).length > 0
      ) {
        return "";
      } else {
        return item && item.name
          ? this.pickBackgroundColor(this.avatarNavbarUserText(item.name))
          : this.pickBackgroundColor(this.avatarNavbarUserText(""));
      }
    },
  },
  mounted() {
    let self = this;
    api.get(`/getUserWorkspaceTypes/${this.$route.params.account_id}`).then(res => {
      const currentWorkspaceTypes = res.data.success.workspaceTypes;
      const workspaceTypes = currentWorkspaceTypes.map((elem) => elem.name);
      this.userAllowedWorkspaces = workspaceTypes;
    }).catch(err => {
      console.log("error getting current users workspaceTypes : ", err);
    })
    self.haveWorkspaceId =
      self.$route.params && self.$route.params.workspace_id
        ? self.$route.params.workspace_id
        : false;
    window.addEventListener("scroll", self.clickListener);
    window.addEventListener("hashchange", self.clickListener, false);
    // this.intervalNotification = setInterval(
    //   () =>
    this.getNotifications();
    //    ,
    //   12000
    // );
    if (document.getElementById("main-panel")) {
      document
        .getElementById("main-panel")
        .addEventListener("click", self.clickListener);
    }
    if (document.getElementById("sidebar")) {
      document
        .getElementById("sidebar")
        .addEventListener("click", self.clickListener);
    }
    this.displayUser(this.$route.params.account_id);
    this.email = localStorage.getItem("email")
      ? localStorage.getItem("email")
      : "";
    this.$watch(
      () => {
        return this.$route.params.account_id;
      },
      (account_id) => {
        if (account_id) {
          this.displayUser(account_id);
        }
      }
    );
    this.$watch(
      () => {
        return this.showModal;
      },
      (showModal) => {
        if (showModal) {
          this.openTodoModal();
        }
      }
    );
  },
};
</script>

<style lang="scss">
.workspaceLogoMainLayout {
  display: flex;
  margin: auto;
  padding-top: 4px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
  cursor: pointer;
}
.accountClass {
  box-shadow: 0 0 black;
  width: 300px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 8px #00000007;
  border-radius: 3px;
  opacity: 1;
  z-index: 1;
  float: right;
  position: fixed;
  margin-top: 50px;
  border-radius: 4px;
  box-shadow: -2px 3px 8px rgba(0, 0, 0, 0.2);
}

.activateProLayout {
  background: #ffd562 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #0000004d;
  border-radius: 15px;
  opacity: 1;
  height: 30px;
  // margin-top: 5px;
  margin-top: auto;
  margin-bottom: auto;
  cursor: pointer;
}

.notifyClose {
  color: #5190ff;
  width: 17px;
  height: 17px;
  cursor: pointer;
}

.read {
  position: absolute;
  right: 0px;
  top: 3px;
  width: 12px;
  height: 12px;
  z-index: 1000;
  border-radius: 50%;
  background: #ff7676 0% 0%;
}

.nineDotsMainDiv1 {
  margin-left: 20px;
  margin-right: 12px;
  margin-top: auto;
  margin-bottom: auto;
}

.workspaceSwitchDropdown .dropdown-menu {
  max-height: 395px;
  overflow-y: auto;
  // margin-top: 5px !important;
}

.workspaceSwitchDropdown .dropdown-menu::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px #e3e3e3;
  border-radius: 10px;
  background-color: #f5f5f5;
}

.workspaceSwitchDropdown .dropdown-menu::-webkit-scrollbar {
  width: 8px;
  background-color: #f5f5f5;
}

.workspaceSwitchDropdown .dropdown-menu::-webkit-scrollbar-thumb {
  border-radius: 6px;
  -webkit-box-shadow: inset 0 0 6px #e3e3e3;
  background-color: #8d8d8d;
}

.workspaceSwitchDropdown {
  align-items: center;
}

.switch-workspace {
  height: 30px;
}

.navbarWorkspaceProfileLogo {
  width: 50px;
  height: 50px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
}

.navbarWorkspaceProfileLogoChild {
  width: 40px;
  height: 40px;
  margin-top: auto;
  margin-bottom: auto;
  display: flex;
}

.navbarProfileAvatar .b-avatar-text {
  font-size: 20px !important;
  color: #000000cc;
}

.navbarProfileAvatarChild .b-avatar-text {
  font-size: 20px !important;
  color: #000000cc;
}
</style>